import { render, staticRenderFns } from "./MixedKeyboard.vue?vue&type=template&id=18d2d54a&scoped=true"
import script from "./MixedKeyboard.vue?vue&type=script&lang=js"
export * from "./MixedKeyboard.vue?vue&type=script&lang=js"
import style0 from "./MixedKeyboard.vue?vue&type=style&index=0&id=18d2d54a&prod&lang=css"
import style1 from "./MixedKeyboard.vue?vue&type=style&index=1&id=18d2d54a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2d54a",
  null
  
)

export default component.exports